import { Badge } from "@/components/ui/badge";
import { APPOINTMENT_STATUS_BADGE } from "@/components/patients/appointment-ui-meta";
import { renderIconBySlug } from "@/lib/event-icons";
import { cn } from "@/lib/utils";

export function AppointmentTypePill({
  clinicType,
}: {
  clinicType?: { name: string; color: string; icon: string } | null;
}) {
  if (!clinicType) return null;
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium text-white"
      style={{ backgroundColor: clinicType.color }}
    >
      {renderIconBySlug(clinicType.icon, { tone: "white", sizeClass: "h-3 w-3" })}
      {clinicType.name}
    </span>
  );
}

export function AppointmentStatusBadge({
  statusKey,
  statusLabel,
  resolvedApplied = false,
}: {
  statusKey?: string | null;
  statusLabel: string;
  resolvedApplied?: boolean;
}) {
  if (resolvedApplied) {
    return (
      <Badge variant="secondary" className="h-6 w-fit text-nowrap">
        {statusLabel}
      </Badge>
    );
  }

  if (!statusKey) {
    return (
      <Badge variant="outline" className="h-6 truncate">
        {statusLabel}
      </Badge>
    );
  }

  return (
    <Badge className={cn("h-6 w-fit", APPOINTMENT_STATUS_BADGE[statusKey] ?? "bg-slate-500 text-white")}>
      {statusLabel}
    </Badge>
  );
}
